// Login keys layout view
import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import AlertMixin from '@/mixins/alert';
import template from '@/../templates/mfa/mfa-layout.hbs';
import MFAValidateDialog from '@/views/dialogs/validate_mfa';
import MFAMethodDialog from '@/views/dialogs/select_mfa_method';
import template_recovery_keys from '@/../templates/mfa/mfa-recovery-keys.hbs';
import template_auth_selection from '@/../templates/mfa/mfa-auth-selection.hbs';
import template_auth_enable from '@/../templates/mfa/mfa-auth-enable.hbs';
import template_production_deploy_auth from '@/../templates/mfa/mfa-production-deploy-auth.hbs';
import template_mfa_collaborator_required from '@/../templates/mfa/mfa-collaborator-required.hbs';

var globalCh = Radio.channel('global');

// A method to download the recovery keys in the collection
function download_keys(collection) {
    var keys_only = collection.pluck("token");
    var file = new Blob([keys_only], { type: 'application/json' });
    var url = URL.createObjectURL(file);
    var dl_link = $(document.getElementsByClassName('download')) || $(document.getElementById('download-keys'));

    dl_link.attr('href', url);
    dl_link.attr('download', 'recovery_keys.txt');
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
    }, 0);
}

// MFA keys management view
var KeysView = Marionette.View.extend({
    className: 'mfa-keys-mgmt',
    template: Handlebars.compile(template_recovery_keys),
    ui: {
        download: '.download',
        manage: '.manage',
    },
    initialize: function() {
        _.bind(download_keys, this);
    },
    events: {
        'click @ui.download': function(e) {
            download_keys(this.collection);
        },
        'click @ui.manage': function(e) {
            globalCh.request('show_mfa_recovery_keys', this.collection, this.model);
        },
    }
});

// View that allows user to require MFA to collaborate on their account
var CollaboratorRequiredView = Marionette.View.extend({
    template: Handlebars.compile(template_mfa_collaborator_required),
    ui: {
        'toggle_mfa_required': '.collaborator-mfa',
    },
    templateContext: function(){
        return {
            collaborator_mfa_required: this.model.get('collaborator_mfa_required')
        };
    },
    events: {
        'click @ui.toggle_mfa_required': 'toggle_mfa_collaborator_requirement',
    },
    toggle_mfa_collaborator_requirement: function(){
        this.model.toggle_require_mfa_for_collaborators( !this.model.get('collaborator_mfa_required') )
        .then(()=>{
            Radio.request('alerts', 'showAlert', {
                message: `Successfully ${this.model.get('collaborator_mfa_required') ? 'enabled' : 'disabled'} collaborator MFA requirements`,
                messageType: 'success',
                timeout: 5000
            });
        })
        .catch(()=>{
            this.ui.toggle_mfa_required.prop('checked', this.model.get('collaborator_mfa_required'));
            Radio.request('alerts', 'showAlert', {
                message: `Error ${!this.model.get('collaborator_mfa_required') ? 'enabling' : 'disabling'} collaborator MFA requirements. Please try again.`,
                messageType: 'danger',
                timeout: 5000
            });
        });
    }
});

// View that allows users to enabled requirement of MFA for Production Device Group Deployments
var ProductionDeployRequired = Marionette.View.extend({
    template: Handlebars.compile(template_production_deploy_auth),
    ui: {
        'toggle_production_mfa_required': '.production-deploy-mfa'
    },
    templateContext: function(){
        return {
            production_deploy_mfa_required: this.model.get('deployment_mfa_required')
        };
    },
    events: {
        'click @ui.toggle_production_mfa_required': 'toggle_mfa_production_requirement'
    },
    toggle_mfa_production_requirement: function() {
        this.model.toggle_require_mfa_for_production( !this.model.get('deployment_mfa_required') )
        .then(()=>{
            Radio.request('alerts', 'showAlert', {
                message: `Successfully ${this.model.get('deployment_mfa_required') ? 'enabled' : 'disabled'} production deployment MFA requirements.`,
                messageType: 'success',
                timeout: 5000
            });
        })
        .catch(()=>{
            this.ui.toggle_production_mfa_required.prop('checked', this.model.get('deployment_mfa_required'));
            Radio.request('alerts', 'showAlert', {
                message: `Error ${!this.model.get('deployment_mfa_required') ? 'enabling' : 'disabling'} production deployment MFA requirements. Please try again.`,
                messageType: 'danger',
                timeout: 5000
            });
        });
    }
});

// View that shows the authentication method chosen
var AuthSelectionView = Marionette.View.extend({
    className: 'mfa-auth-selected',
    template: Handlebars.compile(template_auth_selection),
    ui: {
        disable_method: '.disable-mfa'
    },
    events: {
        'click @ui.disable_method' : 'disable_mfa'
    },
    disable_mfa: function() {
        var view = new MFAValidateDialog({
            model: this.model,
            title: 'Disable Multi-Factor Authentication',
            description: 'To disable Multi-Factor Authentication, please verify your current password.'
        });
        globalCh.request('showDialog', view);
    }
});

var EnableAuthView = Marionette.View.extend({
    className: 'mfa-auth-not-selected',
    template: Handlebars.compile(template_auth_enable),
    ui: {
        enable_method: '.enable-mfa'
    },
    events: {
        'click @ui.enable_method' : 'enable_mfa',
    },
    enable_mfa: function() {
        var view = new MFAMethodDialog({
            model: this.model,
        });
        globalCh.request('showDialog', view);
    }
});

var MFALayoutView = Marionette.View.extend(AlertMixin).extend({
    className: 'mfa',
    id: 'mfa',
    ui: {
        mfa_recovery_keys: '.mfa-recovery-keys-region',
        mfa_method: '.mfa-method-region',
        mfa_collaborator_required: '.mfa-collaborator-required-region',
        mfa_production_deploy: '.mfa-production-deploy'
    },
    regions: {
        mfa_region: '@ui.mfa_region',
        mfa_recovery_keys: '@ui.mfa_recovery_keys',
        mfa_method: '@ui.mfa_method',
        mfa_collaborator_required: '@ui.mfa_collaborator_required',
        mfa_production_deploy: '@ui.mfa_production_deploy'
    },
    initialize: function (options) {
        this.model.fetch();
    },
    templateContext: function () {
        return {
            title: this.getOption('title') || 'Untitled',
        };
    },
    modelEvents: {
        'change': 'render'
    },
    template: Handlebars.compile(template),
    onRender: function () {
        // If enabled, show button to disable and vice versa
        if (this.model.get('mfa_enabled')) {
            this.showChildView('mfa_recovery_keys', new KeysView({ collection: this.collection, model: this.model }));
            this.showChildView('mfa_method', new AuthSelectionView({ model: this.model }));
            this.showChildView('mfa_collaborator_required', new CollaboratorRequiredView({ model: this.model }));
            if (this.model.get('tier') === 'enterprise'){
                this.showChildView('mfa_production_deploy', new ProductionDeployRequired({ model: this.model } ));
            }
        } else {
            this.showChildView('mfa_method', new EnableAuthView({ model: this.model }));
        }
    }
});

export default MFALayoutView;


